import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UserManualComponent} from './user-manual/user-manual.component';
import {NavigationModule} from '../navigation/navigation.module';
import {MatButtonModule, MatIconModule} from '@angular/material';
import {RouterModule} from '@angular/router';
import {CuiNavbarModule} from '@cicero/webui/lib/navigation/navbar';
import {CuiUserManualModule} from '@cicero/webui/lib/help/user-manual';
import {PageNotFoundComponent} from './page-not-found/page-not-found.component';

@NgModule({
  imports: [
    CommonModule,
    NavigationModule,
    MatIconModule,
    MatButtonModule,
    RouterModule,
    CuiNavbarModule,
    CuiUserManualModule
  ],
  declarations: [UserManualComponent, PageNotFoundComponent]
})
export class HelpModule {
}



// WEBPACK FOOTER //
// ./src/app/help/help.module.ts